import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Route } from 'react-router-dom'
import { Switch } from 'react-router'
import Actions from '../../../actions'
import ListView from '../../common/ListView'
import dayjs from 'dayjs'
import $t from '../../../i18n'
import { useRouteMatch } from 'react-router'
import FilePreviewPage from '../FilePreviewPage'
import Page from '../../common/Page'

import './DoctorNotes.css'

const DoctorNotes = () => {
  const dispatch = useDispatch()
  const { path, url } = useRouteMatch()
  const selectedMemberId = useSelector(
    state => state.account?.selectedMember?.id
  )
  const notes = useSelector(state => state.medicalInfo?.currentWorkNotes)
  const isLoading = useSelector(state => state.medicalInfo?.isLoadingDocs)

  const [notesList, setNotesList] = useState([])

  useEffect(() => {
    dispatch(
      Actions.createAction(Actions.SET_WORK_NOTES_BY_ID, {
        id: selectedMemberId,
      })
    )
  }, [selectedMemberId])

  useEffect(() => {
    const data = notes?.map(note => {
      const fileId = note?.file || 0
      return {
        issueDate: dayjs(note?.creationDate).format('DD MMM YYYY'),
        title: $t('pages.notes.type'),
        doctor: note?.doctor?.speciality
          ? `Dr. ${note?.doctor?.firstName} ${note?.doctor?.lastName} | ${note?.doctor?.speciality}`
          : `Dr. ${note?.doctor?.firstName} ${note?.doctor?.lastName}`,
        dateRange: $t('common.from', {
          startDate: dayjs(note?.startDate).format('DD MMM YYYY'),
        }),
        isPressable: !!fileId,
        patientId: note?.patient,
        onClick: () =>
          dispatch(
            Actions.createAction(Actions.NAVIGATED_TO, `${url}/${fileId}`)
          ),
      }
    })
    setNotesList(data)
  }, [notes])

  return (
    <div className="doctor-notes">
      <Switch>
        <Route exact path={path}>
          <Page displayManageFamily title={$t('sideMenu.doctorNotes')}>
            <ListView
              data={notesList}
              dataName="doctor-notes"
              isLoading={isLoading}
              category={$t('sideMenu.doctorNotes').toLowerCase()}
            />
          </Page>
        </Route>
        <Route path={`${path}/:fileId`}>
          <FilePreviewPage isDownloadEnable={true} />
        </Route>
      </Switch>
    </div>
  )
}

export default DoctorNotes
